import { GetServerSideProps } from 'next';
import { BuilderComponent, builder } from '@teko-builder/client';
import React from 'react';
import { logger } from '@teko/log';
import { getEnv } from 'helpers';
import { isMobile } from '@teko/ds-desktop';
import { useTenantConfig } from 'hooks';

const LandingBuilderPage: React.FC = ({ page }: any) => {
  const { terminal, location, getProcessEnv } = useTenantConfig();
  return (
    <BuilderComponent
      content={page?.pbConfig}
      configs={{
        env: getProcessEnv('LANDING_BUILDER_ENV'),
        terminalCode: terminal,
        locationCode: location,
      }}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async (context: any) => {
  // get information provided by middleware
  const lbEnv = getEnv('LANDING_BUILDER_ENV');

  const merchantCode = (context.req as any).tenantEnv.tenant;

  const domain =
    lbEnv === 'production'
      ? `${merchantCode}.landingbuilder.vn`
      : `${merchantCode}.landing.dev.teko.vn`;

  builder.init(domain, {
    env: lbEnv,
  });
  // call to page-build bff to get page data by slug
  const { slug } = context.params;
  const isProd = process.env.NODE_ENV === 'production';
  try {
    const { page, redirect } = await builder.getPublicPage(
      {
        slug,
        device: isMobile ? 'mobile' : 'desktop',
      },
      isProd,
    );
    if (!!redirect) {
      return {
        redirect: {
          statusCode: 301,
          destination: redirect,
        },
        props: {},
      };
    }
    return {
      props: {
        page: page,
      },
    };
  } catch (err) {
    logger.error(err);
    return {
      notFound: true,
    };
  }
};

export default LandingBuilderPage;
